import styles from "./youtube-container.module.css";

export default function YoutubeContainer({
  style: parentStyle,
  embedCode,
  fullWidth,
}) {
  return (
    <div
      className="embed-responsive embed-responsive-16by9"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...parentStyle,
      }}
    >
      <div
        dangerouslySetInnerHTML={{ __html: embedCode }}
        className={fullWidth && styles.iframe_wrapper}
      ></div>
    </div>
  );
}
